module.exports = __webpack_public_path__ + "static/media/cce-badge.c45e20a4.svg";